<template>
  <div class="intro">
    <h1>Dixit</h1>
    <div class="author">Powered by Sweetie pie and Cutie pie</div>
    <button class="button" @click="startANewGame('dixit')">Start a new game</button>
    <button class="button" @click="startANewGame('fbanna')">Start a new Fb.Anna game</button>
  </div>
</template>

<script>
export default {
  name: "Intro",
  methods: {
    startANewGame(variant) {
      this.$store.dispatch('createGame', variant)
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.intro {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}
h1 {
  font-family: "Amatic SC";
  font-size: 62px;
  color: white;
  margin: 0 0 0 0;
}
.author {
  text-transform: uppercase;
  font-family: "Roboto Condensed";
  font-weight: 300;
  font-size: 15px;
  color: #605E84;
  margin-bottom: 40px;
}
button {
  margin-bottom: 20px;
}
</style>
